export default __webpack_public_path__ + "static/media/alena.26e39568.jpg";